export enum CRUD_STATE {
  CREATING,
  READING,
  UPDATING,
  DELETING,
}